const DEFAULT_ITEMS = [
  "Japán-ázsiai tematikájú stúdió",
  "Szeptember 1-jén nyitottunk Budapesten",
  "1064 Budapest, Podmaniczky utca 75.",
  "Steril · Precíz · Exkluzív",
  "Walk-in minden nap",
  "Tetoválás · Piercing · Henna & Jagua",
];

export const Marquee = ({ items = DEFAULT_ITEMS }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-[#202023] bg-[#0F0F11] py-4">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-mono2 text-xs uppercase tracking-[0.3em] text-zinc-500">
                  {item}
                </span>
                <span className="text-zinc-700">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
